import { Section } from '../../types';

export function getIdFromFriendlySectionPath(friendlyPath: string): Section['id'] {
  return friendlyPath.split('-').slice(-1)[0];
}
